// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoContas_ValidarVinculoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /planocontas/validar_vinculo
 *
 * Validates if a despesa can be linked to a plano de contas.
 */
import { registerContract } from './validate'

export interface PlanoContas_ValidarVinculoInput {
despesa_id: number
plano_conta_id: number
}

registerContract('PlanoContas_ValidarVinculoInput', {
  despesa_id:     { type: 'number',  required: true },
  plano_conta_id: { type: 'number',  required: true },
})
